// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/components/email-phone/email-phone.scss
// module id = 236
// module chunks = 0